import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NewsItem } from 'src/app/interfaces';

@Component({
  selector: 'app-innernews',
  templateUrl: './innernews.component.html',
  styleUrls: ['./innernews.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InnernewsComponent implements OnInit {

  @Input() newsItem: NewsItem = null;

  constructor(
    private cdr: ChangeDetectorRef
  ) {
    this.cdr.detach();
  }

  ngOnInit(): void {
    this.cdr.detectChanges();
  }

}
